import React, { useEffect, useRef, useState } from 'react';
import { Select ,Button, DatePicker} from 'antd';
const {Option} = Select;
import cuid from '@paralleldrive/cuid2';
import { useImmer } from 'use-immer';
// ======= self define
import { IAgronomicRedommedationModel, ITemplateOptionsResModel } from '@/util/Request/agrialert/requestType';
import {ForecastOrHistoricalSelectedEnum,AgronomicTypeEnum,
    IAllAgronomicModel,
    ISprayRemainderModel,IPlantingRemainderModel,
    // func
    initSprayFunc,initDiseaseFunc,initPlantingFunc,
    initStressAlertFunc,
    IDiseaseRemainderModel,
    DiseaseCropEnum,
    TimePeriodEnum,
    IRecommendationModel,
    forecastDiseaseOptions,
    initHeatStressRiskFunc,
    initColdStressRiskFunc
} from './initTypeAndFunc';
import IF from '@/components/IF';
import moment from 'moment';
import './index.less';
import { CloseSvg, WeatherStationCloseIcon,AgriAlertClostIcon } from '@/resource/IconComponentSets';
import { DiseaseForecastDays, ForecastDays, HistoricalDays } from '@/page/Agrialert/template-management/template-management';

interface IProp{
    templateOptions: ITemplateOptionsResModel;
    dateFormat: string;
    selectedAgronomic: IAgronomicRedommedationModel[]
    initFlag: boolean;
    childChangeSelectedAgronomic: (data:IAgronomicRedommedationModel[])=>void
    childChangeInitFlag: (data:boolean) => void
}


const AgronomicRecommendations= (prop:IProp)=>{

    const {templateOptions,dateFormat,
        selectedAgronomic,
        initFlag,
        childChangeSelectedAgronomic,
        childChangeInitFlag
    } = prop;

    const [currentAgronomicList,updateCurrentAgronomicList] = useImmer<IAllAgronomicModel[]>([]);


    // 剩余的可选 Options
    const [sprayRemainder,updateSprayRemainder] = useImmer<ISprayRemainderModel>({
        forecast: [],
        historical: []
    });
    const [plantingRemainder,updatePlantingRemainder] = useImmer<IPlantingRemainderModel>({
        forecast: [],
        historical: []
    });
    const [diseaseRemainder,updateDiseaseRemainder] = useImmer<IDiseaseRemainderModel>({
        forecast: {
            Apples: null,
            Canola: null,
            Cereal: null,
            Corn: null,
            Grapes: null,
            Pepper: null,
            Potato: null,
            Sunflower: null,
            Turf: null
        },
        historical:{
            Apples: null,
            Canola: null,
            Cereal: null,
            Corn: null,
            Grapes: null,
            Pepper: null,
            Potato: null,
            Sunflower: null,
            Turf: null
        }
    });

    const isInitialized = useRef<boolean>(false);
    useEffect(()=>{
        if(templateOptions && !isInitialized.current && initFlag){
            console.log('lanxue test4 initFlag',initFlag);
            console.log('lanxue test4 templateOptions',templateOptions);
            if(selectedAgronomic?.length >= 1){
                initValue(true);
            }
            else{
                initValue(false);
                console.log('lanxue init func',templateOptions);
                isInitialized.current = true; // 更新 ref，表示已经初始化
            }
            initDiseaseRiskRemainder();
            initSprayRemainder();
            initPlantingRemainder();
        }
    },[templateOptions,initFlag]);


    const getTimePeriodEnum = (period?: string): TimePeriodEnum | null => {
        switch (period) {
            case '7days':
                return TimePeriodEnum.SEVEN;
            case '14days':
                return TimePeriodEnum.FOURTEEN;
            case 'custom':
                return TimePeriodEnum.CUSTOM;
            default:
                return null; // 如果没有匹配的枚举值，则返回 undefined
        }
    };

    /**
    * when falg is false, mean have no data from api
    * when flag is true, mean already set data
    * @param flag
    */
    const initValue = (flag:boolean)=>{
        const tmpTemplateOptions:ITemplateOptionsResModel = initSortOptions();
        // init current AgronomicList
        if(flag){
            selectedAgronomic?.forEach((item,index)=>{
                let tmpDisease: IRecommendationModel = null;
                let tmpSpray: IRecommendationModel = null;
                let tmpPlanting: IRecommendationModel = null;
                let tmpStressAlert: IRecommendationModel = null;
                let tmpHeatStressRisk: IRecommendationModel = null;
                let tmpColdStressRisk: IRecommendationModel = null;
                // const tmpForecastFlag = item?.isHistorical ? ForecastOrHistoricalSelectedEnum.HISTORICAL :
                //     ForecastOrHistoricalSelectedEnum.FORECAST;
                const tmpForecastFlag = item?.isMixedForecastHistorical ? ForecastOrHistoricalSelectedEnum.MIXFORECASTHISTORICAL:
                    (item?.isHistorical ? ForecastOrHistoricalSelectedEnum.HISTORICAL :
                        ForecastOrHistoricalSelectedEnum.FORECAST
                    )
                ;
                if(item?.agronomicType === AgronomicTypeEnum.DISEASE){
                    let tmpHistorical = true;
                    //if(item?.disease?.crop === 'Potato' && item?.disease?.modelID){
                    if(item?.disease?.crop && item?.disease?.modelID){
                        if(forecastDiseaseOptions.includes(item?.disease?.modelID)){
                            tmpHistorical = false;
                        }
                    }
                    tmpDisease = {
                        forecastOrHistoricalSelected: tmpForecastFlag,
                        isForecast: true,
                        isHistorical: tmpHistorical,
                        cropValue: null,
                        cropOptions: null,
                        diseaseCropValue: item?.disease?.crop,
                        // diseaseValue: item?.disease?.modelID?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                        diseaseValue: item?.disease?.modelID,
                        diseaseOptions: null,
                        forecastDays: item?.forecastDays,
                        historicalDays: item?.historicalDays,
                        // 下面全是给 Historical 用的，看选的是历史的几天
                        historicalTimeSelected: getTimePeriodEnum( item?.historicalSetting?.timePeriod),
                        historicalStartDate: item?.historicalSetting?.startDate,
                        historicalEndDate: item?.historicalSetting?.endDate,
                        disableStartDate: null,
                        disableEndDate: null
                    };
                    tmpSpray = initSprayFunc(tmpTemplateOptions?.spray);
                    tmpPlanting = initPlantingFunc(tmpTemplateOptions?.plantingCrops);
                    tmpStressAlert = initStressAlertFunc(tmpTemplateOptions?.stressAlertType);
                    tmpHeatStressRisk = initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops);
                    tmpColdStressRisk = initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops);
                }
                else if(item?.agronomicType === AgronomicTypeEnum.SPRAY){
                    let tmpHistorical = false;
                    if(item?.spray && item?.spray === 'sw_vixeran_application_timing'){
                        tmpHistorical = true;
                    }
                    tmpSpray = {
                        forecastOrHistoricalSelected: tmpForecastFlag,
                        isForecast: true,
                        isHistorical: tmpHistorical,
                        cropValue: item?.spray,
                        // cropValue: item?.spray?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                        cropOptions: null,
                        diseaseCropValue: null,
                        diseaseValue: null,
                        diseaseOptions: null,
                        forecastDays: item?.forecastDays,
                        historicalDays: item?.historicalDays,
                        // 下面全是给 Historical 用的，看选的是历史的几天
                        historicalTimeSelected: getTimePeriodEnum( item?.historicalSetting?.timePeriod),
                        historicalStartDate: item?.historicalSetting?.startDate,
                        historicalEndDate: item?.historicalSetting?.endDate,
                        disableStartDate: null,
                        disableEndDate: null
                    };
                    tmpDisease = initDiseaseFunc(tmpTemplateOptions?.diseaseCrops);
                    tmpPlanting = initPlantingFunc(tmpTemplateOptions?.plantingCrops);
                    tmpStressAlert = initStressAlertFunc(tmpTemplateOptions?.stressAlertType);
                    tmpHeatStressRisk = initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops);
                    tmpColdStressRisk = initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops);
                }
                else if(item?.agronomicType === AgronomicTypeEnum.PLANTING){
                    tmpPlanting = {
                        forecastOrHistoricalSelected: tmpForecastFlag,
                        isForecast: true,
                        isHistorical: true,
                        cropValue: item?.planting,
                        // cropValue: item?.planting?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                        cropOptions: null,
                        diseaseCropValue: null,
                        diseaseValue: null,
                        diseaseOptions: null,
                        forecastDays: item?.forecastDays,
                        historicalDays: item?.historicalDays,
                        // 下面全是给 Historical 用的，看选的是历史的几天
                        historicalTimeSelected: getTimePeriodEnum( item?.historicalSetting?.timePeriod),
                        historicalStartDate: item?.historicalSetting?.startDate,
                        historicalEndDate: item?.historicalSetting?.endDate,
                        disableStartDate: null,
                        disableEndDate: null
                    };
                    tmpDisease = initDiseaseFunc(tmpTemplateOptions?.diseaseCrops);
                    tmpSpray = initSprayFunc(tmpTemplateOptions?.spray);
                    tmpStressAlert = initStressAlertFunc(tmpTemplateOptions?.stressAlertType);
                    tmpHeatStressRisk = initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops);
                    tmpColdStressRisk = initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops);
                }
                else if(item?.agronomicType === AgronomicTypeEnum.STRESS){
                    tmpStressAlert = {
                        forecastOrHistoricalSelected: tmpForecastFlag,
                        isForecast: true,
                        isHistorical: true,
                        cropValue: item?.stress,
                        // cropValue: item?.planting?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                        cropOptions: null,
                        diseaseCropValue: null,
                        diseaseValue: null,
                        diseaseOptions: null,
                        forecastDays: item?.forecastDays,
                        historicalDays: item?.historicalDays,
                        // 下面全是给 Historical 用的，看选的是历史的几天
                        historicalTimeSelected: getTimePeriodEnum( item?.historicalSetting?.timePeriod),
                        historicalStartDate: item?.historicalSetting?.startDate,
                        historicalEndDate: item?.historicalSetting?.endDate,
                        disableStartDate: null,
                        disableEndDate: null
                    };
                    tmpDisease = initDiseaseFunc(tmpTemplateOptions?.diseaseCrops);
                    tmpSpray = initSprayFunc(tmpTemplateOptions?.spray);
                    tmpPlanting = initPlantingFunc(tmpTemplateOptions?.plantingCrops);
                    tmpHeatStressRisk = initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops);
                    tmpColdStressRisk = initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops);
                }
                else if(item?.agronomicType === AgronomicTypeEnum.HEATSTRESSRISK){
                    tmpHeatStressRisk = {
                        forecastOrHistoricalSelected: tmpForecastFlag,
                        isForecast: true,
                        isHistorical: true,
                        // TODO: need change
                        cropValue: item?.heatStressRisk,
                        cropOptions: null,
                        diseaseCropValue: null,
                        diseaseValue: null,
                        diseaseOptions: null,
                        forecastDays: item?.forecastDays,
                        historicalDays: item?.historicalDays,
                        // 下面全是给 Historical 用的，看选的是历史的几天
                        historicalTimeSelected: getTimePeriodEnum( item?.historicalSetting?.timePeriod),
                        historicalStartDate: item?.historicalSetting?.startDate,
                        historicalEndDate: item?.historicalSetting?.endDate,
                        disableStartDate: null,
                        disableEndDate: null
                    };
                    tmpDisease = initDiseaseFunc(tmpTemplateOptions?.diseaseCrops);
                    tmpSpray = initSprayFunc(tmpTemplateOptions?.spray);
                    tmpPlanting = initPlantingFunc(tmpTemplateOptions?.plantingCrops);
                    tmpStressAlert = initStressAlertFunc(tmpTemplateOptions?.stressAlertType);
                    tmpColdStressRisk = initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops);
                }
                else if(item?.agronomicType === AgronomicTypeEnum.COLDSTRESSRISK){
                    tmpColdStressRisk = {
                        forecastOrHistoricalSelected: tmpForecastFlag,
                        isForecast: true,
                        isHistorical: true,
                        // TODO: need change
                        cropValue: item?.coldStressRisk,
                        cropOptions: null,
                        diseaseCropValue: null,
                        diseaseValue: null,
                        diseaseOptions: null,
                        forecastDays: item?.forecastDays,
                        historicalDays: item?.historicalDays,
                        // 下面全是给 Historical 用的，看选的是历史的几天
                        historicalTimeSelected: getTimePeriodEnum( item?.historicalSetting?.timePeriod),
                        historicalStartDate: item?.historicalSetting?.startDate,
                        historicalEndDate: item?.historicalSetting?.endDate,
                        disableStartDate: null,
                        disableEndDate: null
                    };
                    tmpDisease = initDiseaseFunc(tmpTemplateOptions?.diseaseCrops);
                    tmpSpray = initSprayFunc(tmpTemplateOptions?.spray);
                    tmpPlanting = initPlantingFunc(tmpTemplateOptions?.plantingCrops);
                    tmpStressAlert = initStressAlertFunc(tmpTemplateOptions?.stressAlertType);
                    tmpHeatStressRisk = initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops);
                }
                const tmpAgronomic: IAllAgronomicModel = {
                    sortNumber : item?.sortNumber,
                    agronomicValue : item?.agronomicType,
                    data : {
                        SprayRecommendation : tmpSpray,
                        PlantingRecommendation: tmpPlanting,
                        DiseaseRisk: tmpDisease,
                        StressAlert: tmpStressAlert,
                        HeatStressRisk: tmpHeatStressRisk,
                        ColdStressRisk: tmpColdStressRisk
                    },
                    uuid : cuid.createId()
                };
                updateCurrentAgronomicList(draft => {
                    draft.push(tmpAgronomic);
                });
            });
        }
        else{
            const tmpAgronomic: IAllAgronomicModel = {
                sortNumber : 0,
                agronomicValue : null,
                data : {
                    SprayRecommendation : initSprayFunc(tmpTemplateOptions?.spray),
                    PlantingRecommendation: initPlantingFunc(tmpTemplateOptions?.plantingCrops),
                    DiseaseRisk: initDiseaseFunc(tmpTemplateOptions?.diseaseCrops),
                    HeatStressRisk: initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops),
                    ColdStressRisk: initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops),
                    StressAlert: initStressAlertFunc(tmpTemplateOptions?.stressAlertType)
                },
                uuid : cuid.createId()
            };

            updateCurrentAgronomicList(draft => {
                draft.push(tmpAgronomic);
            });
        }


    };
    const initSortOptions = ():ITemplateOptionsResModel=>{
        const tmpTemplateOptions:ITemplateOptionsResModel = JSON.parse(JSON.stringify(templateOptions));
        // spray Options sort
        tmpTemplateOptions?.spray?.sort((pre,next)=>{
            if(pre?.name < next?.name) return -1;
            if(pre?.name > next?.name) return 1;
            return 0;
        });
        tmpTemplateOptions?.plantingCrops?.sort((pre,next)=>{
            if(pre?.name < next?.name) return -1;
            if(pre?.name > next?.name) return 1;
            return 0;
        });
        tmpTemplateOptions?.disease?.sort((pre,next)=>{
            if(pre?.name < next?.name) return -1;
            if(pre?.name > next?.name) return 1;
            return 0;
        });
        tmpTemplateOptions?.heatStressRiskCrops?.sort((pre,next)=>{
            if(pre?.name < next?.name) return -1;
            if(pre?.name > next?.name) return 1;
            return 0;
        });
        return tmpTemplateOptions;
    };
    const initSprayRemainder = ()=>{
        const tmpTemplateOptions:ITemplateOptionsResModel = initSortOptions();
        updateSprayRemainder(draft =>{
            draft.forecast = tmpTemplateOptions?.spray;
            draft.historical = tmpTemplateOptions?.spray;
        });

    };
    const initPlantingRemainder = ()=>{
        const tmpTemplateOptions:ITemplateOptionsResModel = initSortOptions();
        updatePlantingRemainder(draft =>{
            draft.forecast = tmpTemplateOptions?.plantingCrops;
            draft.historical = tmpTemplateOptions?.plantingCrops;
        });
    };
    const initDiseaseRiskRemainder = ()=>{
        const tmpTemplateOptions:ITemplateOptionsResModel = initSortOptions();
        updateDiseaseRemainder(draft => {
            draft.forecast.Apples = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.APPLES);
            draft.forecast.Canola = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.CANOLA);
            draft.forecast.Cereal = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.CEREAL);
            draft.forecast.Corn = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.CORN);
            draft.forecast.Grapes = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.GRAPES);
            draft.forecast.Pepper = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.PEPPER);
            draft.forecast.Potato = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.POTATO);
            draft.forecast.Sunflower = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.SUNFLOWER);
            draft.forecast.Turf = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.TURF);

            draft.historical.Apples = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.APPLES);
            draft.historical.Canola = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.CANOLA);
            draft.historical.Cereal = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.CEREAL);
            draft.historical.Corn = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.CORN);
            draft.historical.Grapes = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.GRAPES);
            draft.historical.Pepper = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.PEPPER);
            draft.historical.Potato = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.POTATO);
            draft.historical.Sunflower = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.SUNFLOWER);
            draft.historical.Turf = tmpTemplateOptions?.disease.filter(x => x.crop === DiseaseCropEnum.TURF);
        });
    };
    const addAnotherRecommendationFunc = ()=>{
        const tmpCurrentAgronomicList = [...currentAgronomicList];
        const tmpTemplateOptions:ITemplateOptionsResModel = initSortOptions();
        const tmpAgronomic: IAllAgronomicModel = {
            sortNumber : currentAgronomicList?.length,
            agronomicValue : null,
            data : {
                SprayRecommendation : initSprayFunc(tmpTemplateOptions?.spray),
                PlantingRecommendation: initPlantingFunc(tmpTemplateOptions?.plantingCrops),
                DiseaseRisk: initDiseaseFunc(tmpTemplateOptions?.diseaseCrops),
                StressAlert: initStressAlertFunc(tmpTemplateOptions?.stressAlertType),
                HeatStressRisk: initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops),
                ColdStressRisk: initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops)
            },
            uuid : cuid.createId()
        };
        updateCurrentAgronomicList(draft => {
            draft.push(tmpAgronomic);
        });
    };

    const deleteAgronomicItem = (index:number)=>{
        const tmpCurrentAgronomicList:IAllAgronomicModel[] = [];
        if(currentAgronomicList?.length === 1 && index === 0){
            const tmpTemplateOptions:ITemplateOptionsResModel = initSortOptions();
            tmpCurrentAgronomicList.push({
                sortNumber : 0,
                agronomicValue : null,
                data : {
                    SprayRecommendation : initSprayFunc(tmpTemplateOptions?.spray),
                    PlantingRecommendation: initPlantingFunc(tmpTemplateOptions?.plantingCrops),
                    DiseaseRisk: initDiseaseFunc(tmpTemplateOptions?.diseaseCrops),
                    StressAlert: initStressAlertFunc(tmpTemplateOptions?.stressAlertType),
                    HeatStressRisk: initHeatStressRiskFunc(tmpTemplateOptions?.heatStressRiskCrops),
                    ColdStressRisk: initColdStressRiskFunc(tmpTemplateOptions?.coldStressRiskCrops)
                },
                uuid : cuid.createId()
            });
        }
        else{
            currentAgronomicList?.filter( x => x.sortNumber != index).forEach((item,index)=>{
                tmpCurrentAgronomicList.push({
                    ...item,
                    sortNumber: index
                });
            });
        }

        console.log('ddd tmpCurrentAgronomicList',tmpCurrentAgronomicList);
        updateCurrentAgronomicList(draft => {
            // draft = tmpCurrentAgronomicList;
            // 直接修改 draft 的内容
            draft.length = 0; // 清空原数组
            draft.push(...tmpCurrentAgronomicList); // 添加新的数据
        });
    };


    /**
     * used for change Agronomic options, when change, should empty data
     * @param index
     * @param agronomicType
     */
    const publicChangeAgronomicType = (index: number, agronomicType: string)=>{
        updateCurrentAgronomicList(draft =>{
            draft[index].agronomicValue = agronomicType;
            draft[index].data.SprayRecommendation = initSprayFunc(templateOptions?.spray);
            draft[index].data.PlantingRecommendation = initPlantingFunc(templateOptions?.plantingCrops);
            draft[index].data.DiseaseRisk = initDiseaseFunc(templateOptions?.diseaseCrops);
            draft[index].data.StressAlert = initStressAlertFunc(templateOptions?.stressAlertType);
            draft[index].data.HeatStressRisk = initHeatStressRiskFunc(templateOptions?.heatStressRiskCrops);
            draft[index].data.ColdStressRisk = initColdStressRiskFunc(templateOptions?.coldStressRiskCrops);
        });
    };

    /**
     * used for Forecast or Historical change,
     * will change Forecast or Historical type, and empty relate value
     * @param index
     * @param agronomicType
     * @param value
     */
    const updateForecastOrHistoricalType = (index: number, agronomicType: string,value:ForecastOrHistoricalSelectedEnum)=>{

        updateCurrentAgronomicList(draft =>{
            draft[index].data[agronomicType].forecastOrHistoricalSelected = value;
        });
    };


    /**
     * Crop change function, used for Srpay Crop, Crop Type and Crop change
     * @param index
     * @param agronomicType
     * @param value multi selected value, the value is string array
     * @param diseaseCropValue single selected value, the value is string
     */
    const publicChangeCropOptions = (index: number, agronomicType: string,value?:string,diseaseCropValue?: string)=>{

        if(agronomicType === AgronomicTypeEnum.DISEASE){
            if(diseaseCropValue === 'disease'){
                // for disease options change
                //if(currentAgronomicList[index]?.data?.DiseaseRisk?.diseaseCropValue === 'Potato'
                if(currentAgronomicList[index]?.data?.DiseaseRisk?.diseaseCropValue
                    && forecastDiseaseOptions.includes(value)
                ){
                    updateCurrentAgronomicList((darft)=>{
                        darft[index].data[agronomicType].diseaseValue = value;
                        darft[index].data[agronomicType].isHistorical = false;
                        darft[index].data[agronomicType].isForecast = true;
                        darft[index].data[agronomicType].forecastOrHistoricalSelected = null;
                    });
                }
                else{
                    updateCurrentAgronomicList((darft)=>{
                        darft[index].data[agronomicType].diseaseValue = value;
                        darft[index].data[agronomicType].isHistorical = true;
                        darft[index].data[agronomicType].isForecast = true;
                        darft[index].data[agronomicType].forecastOrHistoricalSelected = null;
                    });
                }

            }
            else{
                // fro crop options change
                updateCurrentAgronomicList((darft)=>{
                    darft[index].data[agronomicType].diseaseCropValue = diseaseCropValue;
                    darft[index].data[agronomicType].diseaseValue = null;
                    darft[index].data[agronomicType].isHistorical = true;
                });

            }
        }
        else if(agronomicType === AgronomicTypeEnum.SPRAY){
            if(value === 'sw_vixeran_application_timing'){
                // mean only show historical data
                updateCurrentAgronomicList((darft)=>{
                    darft[index].data[agronomicType].cropValue = value;
                    darft[index].data[agronomicType].isForecast = true;
                    darft[index].data[agronomicType].isHistorical = true;
                    darft[index].data[agronomicType].forecastOrHistoricalSelected = null;
                });
            }
            else{
                updateCurrentAgronomicList((darft)=>{
                    darft[index].data[agronomicType].cropValue = value;
                    darft[index].data[agronomicType].isForecast = true;
                    darft[index].data[agronomicType].isHistorical = false;
                    darft[index].data[agronomicType].forecastOrHistoricalSelected = null;
                });
            }

        }
        else{
            updateCurrentAgronomicList((darft)=>{
                darft[index].data[agronomicType].cropValue = value;
            });
        }
    };

    const updateTimePeriod = (index: number, agronomicType: string,type:string,value?:boolean)=>{
        updateCurrentAgronomicList(draft =>{
            draft[index].data[agronomicType].historicalTimeSelected = type;
        });
    };

    const updateForecastDays = (index: number, agronomicType: string,value?:number)=>{
        updateCurrentAgronomicList(draft =>{
            draft[index].data[agronomicType].forecastDays = value;
        });
    };
    const updateHistoricalDays = (index: number, agronomicType: string,value?:number)=>{
        updateCurrentAgronomicList(draft =>{
            draft[index].data[agronomicType].historicalDays = value;
        });
    };

    const publicChangeCustomDate = (index: number, agronomicType: string,dateType: string,value?:any)=>{
        console.log('lanxue test date: ',value);
        if(dateType === 'startDate'){
            updateCurrentAgronomicList(draft =>{
                draft[index].data[agronomicType].historicalStartDate = value;
            });
        }
        else if(dateType === 'endDate'){
            updateCurrentAgronomicList(draft =>{
                draft[index].data[agronomicType].historicalEndDate = value;
            });
        }
    };

    useEffect(()=>{
        if(currentAgronomicList?.length >= 1){
            const tmpSelectedAgronomic: IAgronomicRedommedationModel[] = [];
            currentAgronomicList?.forEach((item)=>{
                const tmpDisease = {
                    crop: '',
                    modelID: ''
                };
                if(item?.agronomicValue === AgronomicTypeEnum.DISEASE){
                    tmpDisease.crop = item?.data?.DiseaseRisk?.diseaseCropValue,
                    // tmpDisease.modelID = item?.data?.DiseaseRisk.diseaseValue?.join(';');
                    tmpDisease.modelID = item?.data?.DiseaseRisk.diseaseValue;
                }
                const tmpAgronomic:IAgronomicRedommedationModel = {
                    agronomicType : item?.agronomicValue,
                    // isHistorical: item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected === ForecastOrHistoricalSelectedEnum.FORECAST ?
                    //     false : true,
                    isHistorical: item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected === ForecastOrHistoricalSelectedEnum.HISTORICAL ?
                        true : false,
                    isMixedForecastHistorical: item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected === ForecastOrHistoricalSelectedEnum.MIXFORECASTHISTORICAL ?
                        true : false,
                    historicalSetting: {
                        timePeriod: item?.data?.[item?.agronomicValue]?.historicalTimeSelected || '',
                        startDate: item?.data?.[item?.agronomicValue]?.historicalStartDate || '',
                        endDate: item?.data?.[item?.agronomicValue]?.historicalEndDate || '',
                    },
                    forecastDays: item?.data?.[item?.agronomicValue]?.forecastDays || null,
                    historicalDays: item?.data?.[item?.agronomicValue]?.historicalDays || null,
                    spray: item?.agronomicValue === AgronomicTypeEnum.SPRAY ?
                        // item?.data.SprayRecommendation?.cropValue?.join(';') : '',
                        item?.data.SprayRecommendation?.cropValue : '',
                    disease: tmpDisease,
                    planting: item?.agronomicValue === AgronomicTypeEnum.PLANTING ?
                        // item?.data?.PlantingRecommendation?.cropValue?.join(';') : '',
                        item?.data?.PlantingRecommendation?.cropValue : '',
                    stress: item?.agronomicValue === AgronomicTypeEnum.STRESS ?
                        item?.data?.StressAlert?.cropValue : '',
                    heatStressRisk: item?.agronomicValue === AgronomicTypeEnum.HEATSTRESSRISK?
                        item?.data?.HeatStressRisk?.cropValue : '',
                    coldStressRisk: item?.agronomicValue === AgronomicTypeEnum.COLDSTRESSRISK?
                        item?.data?.ColdStressRisk?.cropValue : '',
                    sortNumber: item?.sortNumber,
                };
                tmpSelectedAgronomic.push(tmpAgronomic);
            });
            childChangeSelectedAgronomic(tmpSelectedAgronomic);
            childChangeInitFlag(false);
        }
    },[currentAgronomicList]);


    console.log('lanxue test2 currentAgronomicList',currentAgronomicList);
    console.log('lanxue test2 selectedAgronomic',selectedAgronomic);
    const disabledDate = (current) => {
        // Can't select days after today
        return current && current >= moment().startOf('day');
    };
    return(
        <div className='agronomic-all-container'>
            {/* Agronomic Select button */}
            <div className='agronomicRecommendation-container' id="agronomicRecommendation-container">
                {
                    currentAgronomicList?.map((item,index)=>{
                        return(
                            <>
                                <div className='agronomicType-item-add-conatiner'>
                                    <div
                                        className='agronomicType-item-container'
                                        key={item?.uuid}
                                    >
                                        {/* Agronomic Recommendations options */}
                                        <div
                                            className='agronomicType-container'
                                        >
                                            <span
                                                className='title-span'
                                                style={{marginLeft: '5px'}}>Agronomic Recommendations</span>
                                            <Select
                                                placeholder = 'Select Agronomic'
                                                size = 'large'
                                                value={item?.agronomicValue || null}
                                                onChange={(e)=>{
                                                    publicChangeAgronomicType(index,e);
                                                }}
                                            >
                                                {
                                                    templateOptions?.agronomicType?.map((agronomicTypeItem,agronomicTypeIndex)=>{
                                                        return(
                                                            <>
                                                                <Option
                                                                    className={`${agronomicTypeItem?.code === item.agronomicValue ? 'selected-color' : ''} agronomicType-button basic-button`}
                                                                    key = {agronomicTypeItem?.code}
                                                                    value = {agronomicTypeItem?.code?.toString()}
                                                                >
                                                                    {agronomicTypeItem?.name}
                                                                </Option>
                                                            </>
                                                        );
                                                    })
                                                }
                                            </Select>

                                        </div>

                                        {/* Crop */}
                                        <IF show={!!item?.agronomicValue }>
                                            <div className={`${(item?.agronomicValue === AgronomicTypeEnum.DISEASE ||
                                                                item?.agronomicValue === AgronomicTypeEnum.HEATSTRESSRISK ||
                                                                item?.agronomicValue === AgronomicTypeEnum.COLDSTRESSRISK) ?
                                                'disease-crop-container'
                                                :
                                                'crop-container'}`}>
                                                <span
                                                    className='title-span'
                                                >
                                                    {item?.agronomicValue === AgronomicTypeEnum.SPRAY ?
                                                        'Spray Type' :
                                                        (
                                                            item?.agronomicValue === AgronomicTypeEnum.STRESS ? 'Stress Type' : 'Crop'
                                                        )}
                                                </span>
                                                {/* For Disease */}
                                                <IF show={item?.agronomicValue === AgronomicTypeEnum.DISEASE}>
                                                    <Select
                                                        // className='disease-crop'
                                                        placeholder = 'Select Crop'
                                                        size = 'large'
                                                        value={item?.data?.DiseaseRisk?.diseaseCropValue || null}
                                                        onChange={(e)=>{
                                                            publicChangeCropOptions(index,item?.agronomicValue,
                                                                null,e);
                                                        }}
                                                    >
                                                        {
                                                            (()=>{
                                                                return templateOptions?.diseaseCrops?.map((cropItem, cropIndex) => (
                                                                    <Option
                                                                        key={cropItem + cropIndex}
                                                                        value={cropItem}
                                                                    >
                                                                        {cropItem}
                                                                    </Option>
                                                                ));

                                                            })()
                                                        }
                                                    </Select>
                                                </IF>

                                                {/* For Spray and Planting  and Heat*/}
                                                <IF show={item?.agronomicValue === AgronomicTypeEnum.SPRAY}>
                                                    <Select
                                                        placeholder = 'Select Spray Type'
                                                        size = 'large'
                                                        value={item?.data?.SprayRecommendation?.cropValue || null}
                                                        onChange={(e)=>{
                                                            publicChangeCropOptions(index,item?.agronomicValue,
                                                                e,null);
                                                        }}
                                                    >
                                                        {
                                                            (()=>{
                                                                const tmpSelected = item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected;
                                                                return sprayRemainder?.forecast?.map((sprayItem, sprayIndex) => (
                                                                    <Option
                                                                        key={sprayItem?.code?.toString() + sprayIndex}
                                                                        value={sprayItem?.code}
                                                                    >
                                                                        {sprayItem?.name}
                                                                    </Option>
                                                                ));
                                                            })()
                                                        }
                                                    </Select>
                                                </IF>
                                                <IF show={item?.agronomicValue === AgronomicTypeEnum.PLANTING}>
                                                    <Select
                                                        placeholder = 'Select Crop'
                                                        size = 'large'
                                                        value={item?.data?.PlantingRecommendation?.cropValue || null}
                                                        onChange={(e)=>{
                                                            publicChangeCropOptions(index,item?.agronomicValue,
                                                                e,null);
                                                        }}
                                                    >
                                                        {
                                                            (()=>{
                                                                const tmpSelected = item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected;
                                                                return plantingRemainder?.forecast.map((sprayItem, sprayIndex) => (
                                                                    <Option
                                                                        key={sprayItem?.code?.toString() + sprayIndex}
                                                                        value={sprayItem?.code}
                                                                    >
                                                                        {sprayItem?.name}
                                                                    </Option>
                                                                ));
                                                            })()
                                                        }
                                                    </Select>
                                                </IF>
                                                <IF show={item?.agronomicValue === AgronomicTypeEnum.STRESS}>
                                                    <Select
                                                        placeholder = 'Select Stress Type'
                                                        size = 'large'
                                                        value={item?.data?.StressAlert?.cropValue || null}
                                                        onChange={(e)=>{
                                                            publicChangeCropOptions(index,item?.agronomicValue,
                                                                e,null);
                                                        }}
                                                    >
                                                        {
                                                            (()=>{
                                                                return templateOptions?.stressAlertType?.map((heatItem, heatIndex) => (
                                                                    <Option
                                                                        key={heatItem?.code?.toString() + heatIndex}
                                                                        value={heatItem?.code}
                                                                    >
                                                                        {heatItem?.name}
                                                                    </Option>
                                                                ));
                                                            })()
                                                        }
                                                    </Select>
                                                </IF>
                                                <IF show={item?.agronomicValue === AgronomicTypeEnum.HEATSTRESSRISK}>
                                                    <Select
                                                        placeholder = 'Select Crop'
                                                        size = 'large'
                                                        value={item?.data?.HeatStressRisk?.cropValue || null}
                                                        onChange={(e)=>{
                                                            publicChangeCropOptions(index,item?.agronomicValue,
                                                                e,null);
                                                        }}
                                                    >
                                                        {
                                                            (()=>{
                                                                return templateOptions?.heatStressRiskCrops?.map((heatItem, heatIndex) => (
                                                                    <Option
                                                                        key={heatItem?.code?.toString() + heatIndex}
                                                                        value={heatItem?.code}
                                                                    >
                                                                        {heatItem?.name}
                                                                    </Option>
                                                                ));
                                                            })()
                                                        }
                                                    </Select>
                                                </IF>
                                                <IF show={item?.agronomicValue === AgronomicTypeEnum.COLDSTRESSRISK}>
                                                    <Select
                                                        placeholder = 'Select Crop'
                                                        size = 'large'
                                                        value={item?.data?.ColdStressRisk?.cropValue || null}
                                                        onChange={(e)=>{
                                                            publicChangeCropOptions(index,item?.agronomicValue,
                                                                e,null);
                                                        }}
                                                    >
                                                        {
                                                            (()=>{
                                                                return templateOptions?.coldStressRiskCrops?.map((heatItem, heatIndex) => (
                                                                    <Option
                                                                        key={heatItem?.code?.toString() + heatIndex}
                                                                        value={heatItem?.code}
                                                                    >
                                                                        {heatItem?.name}
                                                                    </Option>
                                                                ));
                                                            })()
                                                        }
                                                    </Select>
                                                </IF>

                                            </div>

                                        </IF>

                                        {/* Disease Options */}
                                        <IF show={!!item?.agronomicValue && item?.agronomicValue === AgronomicTypeEnum.DISEASE &&
                                            !!item?.data?.DiseaseRisk?.diseaseCropValue
                                        }>
                                            <div className='disease-optons-container'>
                                                <span
                                                    className='title-span'
                                                >Disease</span>
                                                <Select
                                                    placeholder = 'Select Disease'
                                                    // mode='multiple'
                                                    size = 'large'
                                                    value={item?.data?.DiseaseRisk?.diseaseValue || null}
                                                    onChange={(e)=>{
                                                        publicChangeCropOptions(index,item?.agronomicValue,
                                                            e,'disease');
                                                    }}
                                                >
                                                    {
                                                        (()=>{
                                                            let finalOptions = [];
                                                            if(item?.data?.DiseaseRisk?.diseaseCropValue){
                                                                finalOptions = [...diseaseRemainder.forecast[item?.data?.DiseaseRisk?.diseaseCropValue]];
                                                            }
                                                            return finalOptions?.map((diseaseItem,diseaseIndex)=>{
                                                                return (
                                                                    <Option
                                                                        key={diseaseItem?.modelID + diseaseIndex}
                                                                        value = {diseaseItem?.modelID}
                                                                    >
                                                                        {diseaseItem?.name}
                                                                    </Option>
                                                                );
                                                            });
                                                        })()
                                                    }
                                                </Select>
                                            </div>
                                        </IF>


                                        {/* Historical of Focecast */}
                                        <IF show={!!item?.agronomicValue &&
                                            (item?.agronomicValue === AgronomicTypeEnum.DISEASE) ?
                                            (item?.data.DiseaseRisk?.diseaseValue?.length >= 1)
                                            :
                                            (item?.data?.[item?.agronomicValue]?.cropValue?.length >= 1)
                                        }>
                                            <div className='time-container'>
                                                <div className='fore-hist-container'>
                                                    <span
                                                        className='title-span'
                                                    >Timeline</span>
                                                    <Select
                                                        placeholder = 'Select Timeline'
                                                        size = 'large'
                                                        value={item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected || null}
                                                        onChange={(e)=>{
                                                            updateForecastOrHistoricalType(index,item?.agronomicValue,
                                                                e);
                                                        }}
                                                    >
                                                        {
                                                            item?.data?.[item?.agronomicValue]?.isForecast &&
                                                            (
                                                                <Option
                                                                    key={cuid.createId() + `${item?.data?.[item?.agronomicValue]?.isForecast ? 'ture' : 'false'}`}
                                                                    value = {'Forecast'}
                                                                >Forecast</Option>
                                                            )

                                                        }
                                                        {
                                                            item?.data?.[item?.agronomicValue]?.isHistorical &&
                                                            (
                                                                <Option
                                                                    key={cuid.createId() + `${item?.data?.[item?.agronomicValue]?.isHistorical ? 'ture' : 'false'}`}
                                                                    value = {'Historical'}
                                                                >Historical</Option>
                                                            )
                                                        }
                                                        {
                                                            item?.data?.[item?.agronomicValue]?.isForecast &&
                                                            item?.data?.[item?.agronomicValue]?.isHistorical &&
                                                            (
                                                                <Option
                                                                    key={cuid.createId() + `${item?.data?.[item?.agronomicValue]?.isForecast ? 'ture' : 'false'}`}
                                                                    value = {ForecastOrHistoricalSelectedEnum.MIXFORECASTHISTORICAL}
                                                                >Forecast + Historical</Option>
                                                            )
                                                        }

                                                    </Select>
                                                </div>
                                                {/* Show Forecast Days */}
                                                <IF show={item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected === ForecastOrHistoricalSelectedEnum.FORECAST}>
                                                    <div className='time-perion-container'>
                                                        <span>Forecast Days</span>
                                                        <Select
                                                            placeholder = 'Select Days'
                                                            size = 'large'
                                                            value={item?.data?.[item?.agronomicValue]?.forecastDays || 7}
                                                            onChange={(e)=>{
                                                                updateForecastDays(index,item?.agronomicValue,
                                                                    e);
                                                            }}
                                                        >
                                                            {
                                                                (item?.agronomicValue === AgronomicTypeEnum.DISEASE ? DiseaseForecastDays : ForecastDays)?.map((timeItem, timeIndex) => (
                                                                    <Option
                                                                        key={timeItem + timeIndex}
                                                                        value={timeItem}
                                                                    >
                                                                        {timeItem + `${timeItem > 1 ? ' days' : ' day'}`}
                                                                    </Option>
                                                                ))
                                                            }
                                                        </Select>



                                                    </div>

                                                </IF>

                                                {/* Show Historical Days */}
                                                <IF show={item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected === ForecastOrHistoricalSelectedEnum.HISTORICAL}>
                                                    <div className='time-perion-container'>
                                                        <span>Time Period</span>
                                                        <Select
                                                            placeholder = 'Select Time Period'
                                                            size = 'large'
                                                            value={item?.data?.[item?.agronomicValue]?.historicalTimeSelected || null}
                                                            onChange={(e)=>{
                                                                updateTimePeriod(index,item?.agronomicValue,
                                                                    e);
                                                            }}
                                                        >
                                                            {
                                                                templateOptions?.historicalTimePeriod?.map((timeItem,timeIndex)=>{
                                                                    return(
                                                                        <>2
                                                                            <Option
                                                                                key={timeItem?.code?.toString() + timeIndex}
                                                                                value = {timeItem?.code?.toString()}
                                                                            >
                                                                                {timeItem?.name}
                                                                            </Option>
                                                                        </>
                                                                    );
                                                                })
                                                            }
                                                        </Select>


                                                    </div>
                                                    <IF show={item?.data?.[item?.agronomicValue]?.historicalTimeSelected === TimePeriodEnum.CUSTOM}>
                                                        <div className='custom-date-container'
                                                            id = 'custom-date-container'
                                                        >
                                                            <div className='custom-date-item'>
                                                                <span>Start Date</span>
                                                                <DatePicker
                                                                    allowClear
                                                                    className='agronomic-datepicker'
                                                                    placeholder='Select Date'
                                                                    value={
                                                                        moment(item?.data?.[item?.agronomicValue]?.historicalStartDate, 'yyyy-MM-DD').isValid() ?
                                                                            moment(item?.data?.[item?.agronomicValue]?.historicalStartDate,'yyyy-MM-DD') : null
                                                                    }
                                                                    format={dateFormat}
                                                                    // disabledDate={item?.data?.[item?.agronomicValue]?.disableStartDate}
                                                                    disabledDate={disabledDate}
                                                                    onChange={(e)=>{
                                                                        publicChangeCustomDate(index,item?.agronomicValue,'startDate',
                                                                            e.format('yyyy-MM-DD'));
                                                                    }}
                                                                    getPopupContainer = {()=>{
                                                                        return document.getElementById('custom-date-container');
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className='custom-date-item'>
                                                                <span>End Date</span>
                                                                <DatePicker
                                                                    allowClear
                                                                    className='agronomic-datepicker'
                                                                    placeholder='Select Date'
                                                                    value={
                                                                        moment(item?.data?.[item?.agronomicValue]?.historicalEndDate, 'yyyy-MM-DD').isValid() ?
                                                                            moment(item?.data?.[item?.agronomicValue]?.historicalEndDate,'yyyy-MM-DD') : null
                                                                    }
                                                                    format={dateFormat}
                                                                    disabledDate={item?.data?.[item?.agronomicValue]?.disableEndDate}
                                                                    onChange={(e)=>{
                                                                        publicChangeCustomDate(index,item?.agronomicValue,'endDate',
                                                                            e.format('yyyy-MM-DD'));
                                                                    }}
                                                                    getPopupContainer = {()=>{
                                                                        return document.getElementById('custom-date-container');
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </IF>
                                                </IF>

                                                {/* Show Mixed Days */}
                                                <IF show={item?.data?.[item?.agronomicValue]?.forecastOrHistoricalSelected === ForecastOrHistoricalSelectedEnum.MIXFORECASTHISTORICAL}>

                                                    <div className='custom-date-container'
                                                        id = 'custom-date-container'
                                                    >
                                                        <div className='custom-date-item'>
                                                            <span>Forecast Days</span>
                                                            <Select
                                                                placeholder = 'Select Days'
                                                                size = 'large'
                                                                value={item?.data?.[item?.agronomicValue]?.forecastDays || 7}
                                                                onChange={(e)=>{
                                                                    updateForecastDays(index,item?.agronomicValue,
                                                                        e);
                                                                }}
                                                            >
                                                                {
                                                                    (item?.agronomicValue === AgronomicTypeEnum.DISEASE ? DiseaseForecastDays : ForecastDays)?.map((timeItem, timeIndex) => (
                                                                        <Option
                                                                            key={timeItem + timeIndex}
                                                                            value={timeItem}
                                                                        >
                                                                            {timeItem + `${timeItem > 1 ? ' days' : ' day'}`}
                                                                        </Option>
                                                                    ))
                                                                }
                                                            </Select>
                                                        </div>
                                                        <div className='custom-date-item'>
                                                            <span>Historical Days</span>
                                                            <Select
                                                                placeholder = 'Select Days'
                                                                size = 'large'
                                                                value={item?.data?.[item?.agronomicValue]?.historicalDays || 7}
                                                                onChange={(e)=>{
                                                                    updateHistoricalDays(index,item?.agronomicValue,
                                                                        e);
                                                                }}
                                                            >
                                                                {
                                                                    HistoricalDays?.map((timeItem, timeIndex) => (
                                                                        <Option
                                                                            key={timeItem + timeIndex}
                                                                            value={timeItem}
                                                                        >
                                                                            {timeItem + `${timeItem > 1 ? ' days' : ' day'}`}
                                                                        </Option>
                                                                    ))
                                                                }
                                                            </Select>
                                                        </div>
                                                    </div>
                                                </IF>

                                            </div>
                                        </IF>



                                    </div>
                                    <div
                                        className='delete-agronomic'
                                        onClick={()=>{
                                            console.log('ddd index',index);
                                            deleteAgronomicItem(index);
                                        }}
                                    >
                                        <AgriAlertClostIcon
                                            // width={12}
                                            // height={12}
                                            // stringColor={'rgb(20, 21, 28)'}
                                        />
                                    </div>
                                </div>

                            </>
                        );
                    })
                }
            </div>
            <div className='agronomic-add-button-container'>
                <button
                    className='add-recommendation-button'
                    onClick={()=>{
                        addAnotherRecommendationFunc();
                    }}
                >+ Add another Recommendations</button>
            </div>

        </div>
    );
};

export default React.memo(AgronomicRecommendations);


